module.exports = {
  schema: {
    name: '客戶群組資料',
    type: 'Object',
    contents: {
      key: {
        type: 'String',
        name: '群組名稱',
        unique: true,
      },
      brandRefs: {
        type: 'Array',
        name: '銷售品牌',
        input: 'select',
        multi: true,
        contents: [{
          type: 'ObjectId',
          reference: 'brands',
          refKeys: ['key', 'name'],
        }],
      },
    },
  },
  index: {
    primary: {
      key: {
        key: 1,
      },
      unique: true,
    },
  },
  ui: {
    list: {
      columns: [
        { key: 'key', width: 300 },
        { key: 'brandRefs', width: 400 },
      ],
    },
    editor: {
      groups: [
        {
          name: '',
          rows: [
            [{ key: 'key' }],
            [{ key: 'brandRefs' }],
          ],
        },
      ],
    },
  },
}



// WEBPACK FOOTER //
// ./src/models/customerGroups.js